var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"hmt-lazy-loading",attrs:{"data-src":`${_vm.url}?setAttribution=mls`,"allowfullscreen":"","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }